/**
 * Message d'erreur renvoyé par les endpoints Exocet.
 *
 * Ils répondent tantôt `{ message: "…" }`, tantôt un tableau dont la première entrée
 * porte le texte — la v1 gérait déjà les deux formes. Sans cette extraction, l'écran
 * n'affiche qu'un libellé générique et perd le motif réel du refus, par exemple
 * « Equipment (23IA538388) est déjà sélectionné pour une création d'intervention ».
 */
export function apiErrorMessage(error: unknown): string | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }

  const { response } = error as { response?: unknown };

  if (typeof response !== 'object' || response === null) {
    return null;
  }

  const { data } = response as { data?: unknown };

  if (typeof data === 'string') {
    return trimmedOrNull(data);
  }

  if (Array.isArray(data)) {
    return typeof data[0] === 'string' ? trimmedOrNull(data[0]) : null;
  }

  if (typeof data === 'object' && data !== null) {
    const { message } = data as { message?: unknown };

    return typeof message === 'string' ? trimmedOrNull(message) : null;
  }

  return null;
}

function trimmedOrNull(value: string): string | null {
  return value.trim() === '' ? null : value.trim();
}
